// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "@firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage'; 
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDb5qFhPISuYE46vakU1hDx4B45HHx54a8",
  authDomain: "dimsum-treats-ims.firebaseapp.com",
  projectId: "dimsum-treats-ims",
  storageBucket: "dimsum-treats-ims.firebasestorage.app",
  messagingSenderId: "677053724535",
  appId: "1:677053724535:web:860d3446e411fcce191372",
  measurementId: "G-90HB5HJ84Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

